import script from "./BusinessInfoViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessInfoViewer.vue?vue&type=script&setup=true&lang=js"

import "./BusinessInfoViewer.vue?vue&type=style&index=0&id=5d3bbf0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d3bbf0f"]])

export default __exports__